import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 12c2.209 0 3.99999-1.791 3.99999-4S9.20891 4 6.99991 4c-2.209 0-4 1.791-4 4s1.791 4 4 4zM17.0001 11.0004v-4h2v4h3.999v1.999h-3.999v4.001h-2v-4.001h-4.001v-1.999h4.001zM12.9999 20v-3.571h-.0011c-.0305-1.4708-1.0051-2.7669-2.4863-3.572C9.52451 13.573 8.31351 14 6.99951 14c-1.313 0-2.524-.427-3.512-1.143-1.48121.8051-2.45679 2.1012-2.48726 3.572l-.000338.0186c-.000267.0175-.0004.0349-.0004.0524s.000133.035.0004.0524V20H12.9999z",
    fill: "currentColor"
  }));
});